import React from 'react';
import { createRoot } from 'react-dom/client';
import CreditLimitSign from './components/credit-limit-sign.jsx';

jQuery(function ($) {
    $('#limit-form-credit-limit').validate({
        rules: {
            amount: "required",
        },
        messages: {
            amount: "Ange önskad kreditgräns",
        },
        submitHandler: function (form, e) {
            sendLimitApplicationCreditLimit(form, e);
        }
    });

    $('#limit-form-about-me').validate({
        rules: {
            amount: "required",
            email: {
                required: true,
                email: true,
            },
            phone_number: {
                required: true,
                validPhoneNumber: "SE",
            },
            civil_status: "required",
            form_of_employment: "required",
            monthly_income: {
                required: true,
                number: true,
            },
        },
        messages: {
            amount: "Ange önskad kreditgräns",
            email: {
                required: "Ange din e-mail",
                email: "Ange en giltig e-mailadress",
            },
            phone_number: {
                required: "Ange ditt telefonnummer",
                validPhoneNumber: "Ange ett giltigt telefonnummer"
            },
            civil_status: "Ange din civilstatus",
            form_of_employment: "Ange din anställningsform",
            monthly_income: {
                required: "Ange månadsinkomst före skatt",
                number: "Ange endast siffror"
            },
        },
        submitHandler: function (form, e) {
            sendLimitApplicationAboutMe(form, e);
        }
    });

    $('#limit-form-economy').validate({
        rules: {
            monthly_mortgage_expenses: {
                required: {
                    depends: function () {
                        return ($('input[name="have_mortgage"]:checked').val() == "true");
                    }
                },
            },
            monthly_loan_expenses: {
                required: {
                    depends: function () {
                        return ($('input[name="have_other_loans"]:checked').val() == "true");
                    },
                },
            },
            capital_debt_loans: {
                required: {
                    depends: function () {
                        return ($('input[name="have_other_loans"]:checked').val() == "true");
                    },
                },
            },
            personal_guarantee_amount: {
                required: {
                    depends: function () {
                        return ($('input[name="have_personal_guarantee"]:checked').val() == "true");
                    },
                },
            },
            adults_in_household: {
                required: true,
                number: true,
                min: 0,
            },
            children_in_household: {
                required: true,
                number: true,
                min: 0,
            },
            form_of_housing: "required",
            rent_amount: "required",
            number_of_cars: {
                required: true,
                number: true,
                min: 0,
                max: 15,
            },
            payment_remark: "required",
            have_mortgage: "required",
            have_other_loans: "required",
            have_personal_guarantee: "required",
        },
        messages: {
            personal_guarantee_amount: "Ange belopp för borgensåtagande",
            adults_in_household: {
                required: "Ange antal vuxna i hushållet",
                number: "Ange endast siffror",
                min: "Ange minst 0 vuxna",
            },
            children_in_household: {
                required: "Ange antal barn under 18 år i hushållet",
                number: "Ange endast siffror",
                min: "Ange minst 0 barn",
            },
            form_of_housing: "Ange typ av boende",
            monthly_loan_expenses: "Ange månadskostnad för lån",
            monthly_mortgage_expenses: "Ange månadskostnad för bolån",
            capital_debt_loans: "Ange kapitalskuld för lån",
            rent_amount: "Ange hyreskostnad",
            number_of_cars: {
                required: "Ange antalet bilar",
                number: "Ange endast siffror",
                min: "Ange minst 0 bilar",
                max: "Ange max 15 bilar",
            },
            payment_remark: "Ange om du har betalningsanmärkningar",
            have_mortgage: "Ange om du har bolån",
            have_other_loans: "Ange om du har andra lån",
            have_personal_guarantee: "Ange om du har borgensåtagande",
        },
        submitHandler: function (form, event) {
            sendLimitApplicationEconomy(form, event);
        }
    });

    $('#limit-form-summary').validate({
        rules: {
            villkor: "required",
        },
        messages: {
            villkor: "Vänligen acceptera villkoren",
        },
        submitHandler: function (form, event) {
            sendLimitApplication(form, event);
        }
    });


    /**
     * Handles the submission of the credit limit step of the application form.
     * Prevents the default form submission, shows a loader, serializes the form data,
     * and sends it via an AJAX POST request to save the application data.
     * Redirects to the next step on success or displays an error message on failure.
     *
     * @param {HTMLFormElement} form - The form element being submitted.
     * @param {Event} e - The event object associated with the form submission.
     */
    function sendLimitApplicationCreditLimit(form, e) {
        e.preventDefault();
        $('.application-loader').removeClass('hidden');

        var form_data = $(form).serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        var data = {
            action: 'save_application_data',
            security: CGILimitAjax.security,
            data: {
                application_type: 'CreditLimit',
                credit_limit_amount: form_data.credit_limit_amount,
            }
        }

        $.post(CGILimitAjax.ajaxurl, data, function (response) {
            if (response.success) {
                window.location.assign(CGILimitAjax.limitApplication + 'om-mig/');
            } else {
                try {
                    $('.application-form-wrapper .cgi-status').html(response.data.message).removeClass('hidden');
                }
                catch {
                    $('.application-form-wrapper .cgi-status').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').removeClass('hidden');
                }
                $('.application-loader').addClass('hidden');
            }
        });
    }

    /**
     * Handles the submission of the first step of the application form.
     * Prevents the default form submission, shows a loader, serializes the form data,
     * and sends it via an AJAX POST request to save the application data.
     * Redirects to the next step on success or displays an error message on failure.
     *
     * @param {HTMLFormElement} form - The form element being submitted.
     * @param {Event} e - The event object associated with the form submission.
     */
    function sendLimitApplicationAboutMe(form, e) {
        e.preventDefault();
        $('.application-loader').removeClass('hidden');

        var form_data = $(form).serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        var data = {
            action: 'save_application_data',
            security: CGILimitAjax.security,
            data: {
                application_type: 'CreditLimit',
                monthly_income: form_data.monthly_income,
                form_of_employment: form_data.form_of_employment,
                civil_status: form_data.civil_status,
                email: form_data.email,
                phone_number: form_data.phone_number,
            }
        }

        $.post(CGILimitAjax.ajaxurl, data, function (response) {
            if (response.success) {
                window.location.assign(CGILimitAjax.limitApplication + 'ekonomi/');
            } else {
                try {
                    $('.application-form-wrapper .cgi-status').html(response.data.message).removeClass('hidden');
                }
                catch {
                    $('.application-form-wrapper .cgi-status').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').removeClass('hidden');
                }
                $('.application-loader').addClass('hidden');
            }
        });
    }

    /**
     * Handles the submission of the second step of the application form.
     * Prevents the default form submission, shows a loader, serializes the form data,
     * and sends it via an AJAX POST request to save the application data.
     *
     * @param {HTMLFormElement} form - The form element being submitted.
     * @param {Event} event - The event object associated with the form submission.
     */
    function sendLimitApplicationEconomy(form, event) {
        event.preventDefault();
        $('.application-loader').removeClass('hidden');

        var form_data = $(form).serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        var data = {
            action: 'save_application_data',
            security: CGILimitAjax.security,
            data: {
                application_type: 'CreditLimit',
                form_of_housing: form_data.form_of_housing,
                have_mortgage: form_data.have_mortgage == 'true' ? 1 : 0,
                have_other_loans: form_data.have_other_loans == 'true' ? 1 : 0,
                number_of_cars: form_data.number_of_cars,
                payment_remark: form_data.payment_remark == 'true' ? 1 : 0,
                adults_in_household: form_data.adults_in_household,
                children_in_household: form_data.children_in_household,
                rent_amount: form_data.rent_amount,
                have_personal_guarantee: form_data.have_personal_guarantee == 'true' ? 1 : 0,
            }
        }

        if (form_data.have_mortgage == 'true') {
            data.data.monthly_mortgage_expenses = form_data.monthly_mortgage_expenses;
        } else {
            data.data.monthly_mortgage_expenses = 'null';
        }

        if (form_data.have_other_loans == 'true') {
            data.data.monthly_loan_expenses = form_data.monthly_loan_expenses;
            data.data.capital_debt_loans = form_data.capital_debt_loans;
        } else {
            data.data.monthly_loan_expenses = 'null';
            data.data.capital_debt_loans = 'null';
        }

        if (form_data.have_personal_guarantee == 'true') {
            data.data.personal_guarantee_amount = form_data.personal_guarantee_amount;
        } else {
            data.data.personal_guarantee_amount = 'null';
        }

        $.post(CGILimitAjax.ajaxurl, data, function (response) {
            if (response.success) {
                window.location.assign(CGILimitAjax.limitApplication + 'sammanfattning/');
            } else {
                try {
                    $('.application-form-wrapper .cgi-status').html(response.data.message).removeClass('hidden');
                }
                catch {
                    $('.application-form-wrapper .cgi-status').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').removeClass('hidden');
                }
                $('.application-loader').addClass('hidden');
            }
        });
    }

    /**
     * Send the application to Customer API.
     *
     * @param {Event} event - The event object associated with the form submission.
     */
    function sendLimitApplication() {
        var data = {
            action: 'credit_limit',
            security: CGILimitAjax.security,
        }
        $('.application-loader').removeClass('hidden');

        $.post(CGILimitAjax.ajaxurl, data, function (response) {
            if (response.success) {
                if (response.data.preliminary_decision == "Approved") {
                    window.location.assign(CGILimitAjax.limitApplication + 'kundkannedom/');
                } else {
                    window.location.assign(CGILimitAjax.limitApplication + 'avslag/');
                }
            } else {
                try {
                    $('.application-form-wrapper .cgi-status').html(response.data.message).removeClass('hidden');
                }
                catch {
                    $('.application-form-wrapper .cgi-status').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').removeClass('hidden');
                }
                $('.application-loader').addClass('hidden');
            }
        });
    };

    let creditLimitStatusPoll = $('#credit-limit-status-poll');

    if (creditLimitStatusPoll.length) {
        let applicationId = creditLimitStatusPoll.data('application-id');
        const approvedCreditLimit = new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(creditLimitStatusPoll.data('approved-credit-limit'));
        let steps = creditLimitStatusPoll.data('steps');

        async function getCreditLimitDecision(applicationId) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: CGIAjax.ajaxurl,
                    data: {
                        action: 'credit_limit_decision',
                        application_id: applicationId,
                        security: CGIAjax.security,
                    },
                    success: function (response) {
                        if (!response.success) {
                            return reject();
                        }
                        resolve(response.data.decision);
                    },
                    error: function () {
                        reject();
                    }
                });
            });
        }

        async function pollCreditLimitStatus(remainingSteps) {
            if (remainingSteps <= 0){
                $('.cgi-progress-text').html('<h2>Manuell behandling</h2><p>Din ansökan kräver manuell behandling.</p>');
                return;
            };

            try {
                let status = await getCreditLimitDecision(applicationId);

                $('.cgi-progress-bar').width(`${(steps - remainingSteps + 2) / steps * 100}%`);

                switch (status) {
                    case 'Granted':
                        $('.cgi-progress-text').html(`<h2>Ansökan godkänd</h2><p>Ny kreditgräns: ${approvedCreditLimit}<br />Din nya limit kommer uppdateras inom kort (Kan ta upp till 10 minuter). <br />Har den inte uppdaterats inom denna tid så kan du behöva logga ut och logga in på nytt.</p><a href=${CGIAjax.myPagesOverview} class="et_pb_button cgi-submit-input" style="display: inline-flex; margin-top: 1rem">OK</a>`);
                        break;
                    case 'Denied':
                        $('.cgi-progress-text').html(`<h2>Ansökan nekad</h2><p>Beslutet är fattat efter att en kreditprövning gjorts. Detta är en helhetsbedömning där vi bland annat tagit hänsyn till din inkomst, befintlig skuld, antal kreditförfrågningar samt eventuella betalningsanmärkningar.</p><a href=${CGIAjax.myPagesOverview} class="et_pb_button cgi-submit-input" style="display: inline-flex; margin-top: 1rem">OK</a>`);
                        break;
                    case 'Pending':
                        setTimeout(function () {
                            pollCreditLimitStatus(remainingSteps - 1);
                        }, 1000);
                        break;
                }
            } catch {
                $('.cgi-progress-text').html(`<h2>Något har gått fel</h2><p>Vi upplever problem när vi hämtar status på din ansökan. Vänligen kontakta kundtjänst om din limit inte uppdateras inom kort.</p><a href=${CGIAjax.myPagesOverview} class="et_pb_button cgi-submit-input" style="display: inline-flex; margin-top: 1rem">OK</a>`);
            }
        }

        pollCreditLimitStatus(steps);
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const signDiv = document.getElementById('credit-limit-sign');

    if (signDiv) {
        const root = createRoot(signDiv);
        const urlParams = new URLSearchParams(window.location.search);
        const transactionId = urlParams.get('transactionId');

        root.render(
            <div className="cgi-login-form-wrapper application-loader-wrapper">
                <div className="cgi-login-form">
                    <CreditLimitSign transaction={transactionId || ''} />
                </div>
            </div>
        );
    }
});
